export const generateKey = (categoryName?: string, subCategoryName?: string) =>
  categoryName && subCategoryName ? `${categoryName}_${subCategoryName}` : "";
